import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function InReviewQSetListNoRowsOverlay() {
  return (
    <NoRowsOverlay title='ไม่มีชุดข้อสอบที่อยู่ระหว่างการตรวจสอบ' icon={DescriptionOutlinedIcon} />
  );
}
